import { Typography } from "antd";

export const ConfirmOtpModalTitle = ({
  title,
  titleClassName,
}: {
  title: React.ReactNode | string;
  titleClassName?: string | undefined;
}) => {
  return typeof title === "string" ? (
    <Typography.Title level={1} className={titleClassName}>
      {title}
    </Typography.Title>
  ) : (
    title
  );
};
